import { useMemo } from 'react';
import { ReactionsManager } from 'features/room-reactions/utils/ReactionsManager';

export const useReactionsManager = () => useMemo(() => ReactionsManager, []);
